import { logInternalError } from './errors';

/** Also read verbatim by the OneTrust bootstrap in public/index.html — rename in both places. */
const SESSION_KEY = 'fi_in_app';

/** Checks URL for `utm_source=fi_app` and persists to sessionStorage for the webview session. */
export function initInAppShop() {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('utm_source') !== 'fi_app') {
      return;
    }
    sessionStorage.setItem(SESSION_KEY, 'true');
  } catch (err) {
    logInternalError(err, { tags: { context: 'initInAppShop' } });
  }
}

export function isInAppShop(): boolean {
  try {
    return sessionStorage.getItem(SESSION_KEY) === 'true';
  } catch (err) {
    logInternalError(err, { tags: { context: 'isInAppShop' } });
    return false;
  }
}
